import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { TrendingUp } from 'lucide-react';

export function EarningsChart({ data, period }) {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-surface p-3 rounded-lg border border-border shadow-lg">
          <p className="text-sm text-text-secondary">{payload?.[0]?.payload?.date}</p>
          <p className="text-lg font-semibold text-green-500">
            ${payload?.[0]?.value?.toFixed(2)}
          </p>
          {payload?.[0]?.payload?.status && (
            <p className="text-xs text-text-secondary mt-1 capitalize">
              Status: {payload?.[0]?.payload?.status}
            </p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-surface p-6 rounded-xl border border-border">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-primary" />
          <h3 className="text-lg font-semibold text-text-primary">Earnings Trend</h3>
        </div>
        <span className="text-sm text-text-secondary capitalize">{period} View</span>
      </div>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <defs>
              <linearGradient id="earningsGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-surface, #2a2a2a)" />
            <XAxis
              dataKey="date"
              stroke="var(--color-text-tertiary)"
              tick={{ fill: 'var(--color-text-secondary)' }}
              tickLine={{ stroke: 'var(--color-border)' }}
            />
            <YAxis
              stroke="var(--color-text-tertiary)"
              tick={{ fill: 'var(--color-text-secondary)' }}
              tickLine={{ stroke: 'var(--color-border)' }}
              tickFormatter={(value) => `$${value}`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="earnings"
              stroke="var(--color-accent)"
              strokeWidth={2}
              fill="url(#earningsGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}